'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var styled = require('styled-components');
var colorPalette = require('./color-palette-14d554dc.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var hooks_useSanitizedUrl = require('./hooks/use-sanitized-url/index.js');
var logoLibrary_ownUpLogo = require('./logo-library/own-up-logo/index.js');
var logoLibrary_ownUpLogoWithText = require('./logo-library/own-up-logo-with-text/index.js');
var Link = require('./Link-d540ccdb.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _excluded = ["logoRef", "href", "component", "to", "role"],
  _excluded2 = ["logoRef", "href", "role", "component", "to"];
var _templateObject, _templateObject2, _templateObject3;
var LinkStyle = styled__default['default'](Link.Link)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: pointer;\n"])));
/**
 * The width is tuned to the wordmark.
 */
var logoStyleMixin = styled.css(["& svg{height:3rem;", "{height:2.375rem;width:", ";}", "{height:2.125rem;width:", ";}}display:inline-block;line-height:0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down('md');
}, function (_ref2) {
  var hasText = _ref2.hasText;
  return hasText ? '8.75rem' : '1.6565rem';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down('xs');
}, function (_ref4) {
  var hasText = _ref4.hasText;
  return hasText ? '7.815rem' : '1.475rem';
});
var logoLinkStyleMixin = styled.css(["& a{border:2px solid transparent;&", "{border:2px solid ", ";border-radius:4px;outline:none;}&:focus{outline-style:unset;}}"], focusVisibleSelector.focusVisibleSelectorMixin, colorPalette.ALOE_100);
var LogoStyle = styled__default['default'].span(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n"])), logoStyleMixin);
var LogoLinkStyle = styled__default['default'].span(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), logoStyleMixin, logoLinkStyleMixin);
var OwnUpLogoWithText = function OwnUpLogoWithText() {
  return /*#__PURE__*/React__default['default'].createElement(LogoStyle, {
    hasText: true
  }, /*#__PURE__*/React__default['default'].createElement(logoLibrary_ownUpLogoWithText.OwnUpLogoWithTextSvg, null));
};
var OwnUpLogoWithTextLink = function OwnUpLogoWithTextLink(_ref5) {
  var logoRef = _ref5.logoRef,
    href = _ref5.href,
    component = _ref5.component,
    to = _ref5.to,
    role = _ref5.role,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React__default['default'].createElement(LogoLinkStyle, _rollupPluginBabelHelpers._extends({
    hasText: true,
    ref: logoRef
  }, props), /*#__PURE__*/React__default['default'].createElement(LinkStyle, {
    href: hooks_useSanitizedUrl.useSanitizedUrl(href),
    "aria-label": "return to homepage",
    component: component,
    to: to,
    role: role
  }, /*#__PURE__*/React__default['default'].createElement(logoLibrary_ownUpLogoWithText.OwnUpLogoWithTextSvg, null)));
};
var OwnUpLogo = function OwnUpLogo() {
  return /*#__PURE__*/React__default['default'].createElement(LogoStyle, null, /*#__PURE__*/React__default['default'].createElement(logoLibrary_ownUpLogo.OwnUpLogoSvg, null));
};
var OwnUpLogoLink = function OwnUpLogoLink(_ref6) {
  var logoRef = _ref6.logoRef,
    href = _ref6.href,
    role = _ref6.role,
    component = _ref6.component,
    to = _ref6.to,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/React__default['default'].createElement(LogoLinkStyle, _rollupPluginBabelHelpers._extends({
    hasText: false,
    ref: logoRef
  }, props), /*#__PURE__*/React__default['default'].createElement(LinkStyle, {
    href: hooks_useSanitizedUrl.useSanitizedUrl(href),
    "aria-label": "return to homepage",
    component: component,
    to: to,
    role: role
  }, /*#__PURE__*/React__default['default'].createElement(logoLibrary_ownUpLogo.OwnUpLogoSvg, null)));
};

exports.LogoLinkStyle = LogoLinkStyle;
exports.LogoStyle = LogoStyle;
exports.OwnUpLogo = OwnUpLogo;
exports.OwnUpLogoLink = OwnUpLogoLink;
exports.OwnUpLogoWithText = OwnUpLogoWithText;
exports.OwnUpLogoWithTextLink = OwnUpLogoWithTextLink;
exports.logoLinkStyleMixin = logoLinkStyleMixin;
exports.logoStyleMixin = logoStyleMixin;
//# sourceMappingURL=component-a6756b54.js.map
